var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar pl-3 pt-3" }, [
    _vm.leftPane === "Ontologies"
      ? _c("div", [_c("ontologies-left-pane")], 1)
      : _vm._e(),
    _vm._v(" "),
    _vm.browserName === "ie"
      ? _c("div", [
          _vm._v(
            "\n    Treeview is not supported on Internet Explorer. Please use Firefox, Chrome or Safari!\n  "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.browserName !== "ie"
      ? _c("div", [
          _vm.leftPane === "SkosTree"
            ? _c("div", [_c("skos-tree", { attrs: { node: _vm.skosRoot } })], 1)
            : _vm._e(),
          _vm._v(" "),
          _vm.leftPane === "ClassTree"
            ? _c(
                "div",
                [_c("class-tree", { attrs: { node: _vm.classRoot } })],
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copyright m-4" }, [
      _c("div", { staticClass: "mv-4" }, [
        _c(
          "a",
          {
            attrs: {
              href:
                "http://www.wageningenur.nl/nl/Expertises-Dienstverlening/Onderzoeksinstituten/food-biobased-research.htm"
            }
          },
          [_c("img", { attrs: { src: "/static/images/FBR-black.png" } })]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-4" }, [
        _vm._v("\n        © 2013-2026 Wageningen UR/Food & Biobased Research"),
        _c("br"),
        _vm._v("\n        Consumer Science & Intelligent Systems\n    ")
      ]),
      _vm._v(" "),
      _c("div", {}, [
        _c(
          "a",
          { attrs: { href: "http://www.commit-nl.nl/projects/e-foodlab" } },
          [
            _c("img", {
              attrs: { src: "/static/images/commit-efoodlab-black.png" }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-4" }, [
        _vm._v(
          "\n        eFoodLab is a project within Commit/, a public-private research community solving grand challenges in information and communication science shaping tomorrow's society.\n    "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d622f5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d622f5c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = null
// module chunks = 